/* PM - popover inteligente para descripcion corta de product cards.
   Deteccion de truncado REAL (nunca por longitud de caracteres):
   compara clientHeight (con el -webkit-line-clamp activo, tal como
   esta hoy en pm-card-short-description.css) contra el scrollHeight
   natural del mismo elemento con el clamp temporalmente desactivado
   (toggle in-place de webkitLineClamp/lineClamp, sin clonar nodos).
   El texto completo del popover se toma de el.textContent -- el DOM
   ya contiene el texto completo, el clamp solo lo recorta visualmente,
   asi que no hace falta duplicarlo en un data-attribute.

   Un unico popover global (portal en document.body) reutilizado por
   todas las cards -- nunca overflow:hidden de la card, nunca 1 nodo
   tooltip por card. ResizeObserver por elemento (no window resize
   listener) revalida el truncado cuando el layout de la card cambia
   (grid recalculado, breakpoint, etc.). MutationObserver liviano
   sobre document.body detecta cards renderizadas despues (Ajax/quick
   add/Theme Editor) y solo procesa los nodos nuevos.

   Desktop (hover-capable): mouseover/focusin abren, mouseout/focusout
   cierran, Escape cierra. Mobile/touch (mismo criterio de deteccion
   que pm-card-commerce.css/pm-card-status-dot.js): tap abre/cierra,
   tap fuera cierra -- nunca ambos mecanismos a la vez en el mismo
   dispositivo, para evitar el conflicto clasico hover+tap en touch. */
(function () {
  if (window.pmCardDescriptionHoverInit) return;
  window.pmCardDescriptionHoverInit = true;

  var SELECTOR = '.pm-card-short-description';
  var isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;

  var popover = null;
  var activeTrigger = null;
  var ro = 'ResizeObserver' in window ? new ResizeObserver(handleResize) : null;

  function ensurePopover() {
    if (popover) return popover;
    popover = document.createElement('div');
    popover.className = 'pm-description-popover';
    popover.id = 'PmDescriptionPopover';
    popover.setAttribute('role', 'tooltip');
    popover.hidden = true;
    document.body.appendChild(popover);
    return popover;
  }

  function measure(el) {
    var clampedHeight = el.clientHeight;
    var prevWebkitClamp = el.style.webkitLineClamp;
    var prevClamp = el.style.lineClamp;

    el.style.webkitLineClamp = 'unset';
    el.style.lineClamp = 'unset';
    var naturalHeight = el.scrollHeight;
    el.style.webkitLineClamp = prevWebkitClamp;
    el.style.lineClamp = prevClamp;

    var truncated = naturalHeight - clampedHeight > 1;
    el.setAttribute('data-pm-description-truncated', truncated ? 'true' : 'false');

    if (truncated) {
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'button');
      if (!el.hasAttribute('aria-expanded')) el.setAttribute('aria-expanded', 'false');
      el.setAttribute('aria-describedby', 'PmDescriptionPopover');
    } else {
      el.removeAttribute('tabindex');
      el.removeAttribute('role');
      el.removeAttribute('aria-expanded');
      el.removeAttribute('aria-describedby');
      if (activeTrigger === el) close();
    }
  }

  function handleResize(entries) {
    entries.forEach(function (entry) {
      measure(entry.target);
    });
  }

  function scanNew() {
    var nodes = document.querySelectorAll(SELECTOR + ':not([data-pm-description-scanned])');
    if (!nodes.length) return;
    nodes.forEach(function (el) {
      el.setAttribute('data-pm-description-scanned', '1');
      measure(el);
      if (ro) ro.observe(el);
    });
  }

  function isTruncatedTrigger(el) {
    return !!el && el.getAttribute('data-pm-description-truncated') === 'true';
  }

  function positionPopover(trigger, pop) {
    var gap = 8;
    var rect = trigger.getBoundingClientRect();
    var popRect = pop.getBoundingClientRect();
    var viewportW = document.documentElement.clientWidth;
    var viewportH = document.documentElement.clientHeight;

    var top = rect.bottom + gap;
    if (top + popRect.height > viewportH && rect.top - gap - popRect.height >= 0) {
      top = rect.top - gap - popRect.height;
      pop.classList.add('pm-description-popover--above');
    } else {
      pop.classList.remove('pm-description-popover--above');
    }

    var left = rect.left;
    if (left + popRect.width > viewportW - gap) {
      left = viewportW - gap - popRect.width;
    }
    if (left < gap) left = gap;

    pop.style.top = top + 'px';
    pop.style.left = left + 'px';
  }

  function open(trigger) {
    if (activeTrigger === trigger) return;
    if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'false');

    var pop = ensurePopover();
    pop.textContent = trigger.textContent.trim();
    activeTrigger = trigger;
    pop.hidden = false;
    positionPopover(trigger, pop);
    trigger.setAttribute('aria-expanded', 'true');
  }

  function close() {
    if (!activeTrigger) return;
    activeTrigger.setAttribute('aria-expanded', 'false');
    activeTrigger = null;
    if (popover) popover.hidden = true;
  }

  if (!isTouch) {
    document.addEventListener('mouseover', function (event) {
      var el = event.target.closest(SELECTOR);
      if (isTruncatedTrigger(el)) open(el);
    });

    document.addEventListener('mouseout', function (event) {
      var el = event.target.closest(SELECTOR);
      if (el && el === activeTrigger) close();
    });
  }

  document.addEventListener('focusin', function (event) {
    var el = event.target.closest(SELECTOR);
    if (isTruncatedTrigger(el)) open(el);
  });

  document.addEventListener('focusout', function (event) {
    if (activeTrigger && event.target === activeTrigger) close();
  });

  document.addEventListener('keydown', function (event) {
    if ((event.key === 'Escape' || event.key === 'Esc') && activeTrigger) close();
  });

  if (isTouch) {
    document.addEventListener('click', function (event) {
      var el = event.target.closest(SELECTOR);

      if (isTruncatedTrigger(el)) {
        event.preventDefault();
        event.stopPropagation();
        if (activeTrigger === el) {
          close();
        } else {
          open(el);
        }
        return;
      }

      if (activeTrigger && !(popover && popover.contains(event.target))) {
        close();
      }
    });
  }

  scanNew();

  if ('MutationObserver' in window) {
    new MutationObserver(scanNew).observe(document.body, { childList: true, subtree: true });
  }
})();
